import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';

import MessagesList from '../../../../messages-list/MessagesList';
import { RESONANCE_SORT, SORT_ORDER } from '../../../../../../constants';
import TopMessagesTableFilters from './TopMessagesTableFilters';
import useFilterResonanceMessages from '../../../../../../hooks/useFilterResonanceMessages';
import safeSum from '../../../../../../utils/safeSum';

import scss from '../TopMessages.module.scss';

function TopMessagesTable({ appliedFilters, selectedMessage, onMessageSelect }) {
  const { id: projectId } = useParams();
  const [size, setSize] = useState(null);
  const [sort, setSort] = useState(COMMON_MESSAGE_SORT);
  const [search, setSearch] = useState('');

  const handleChangeSort = ({ sort, direction, getSortValue }) => {
    setSort({ sort, direction, getSortValue });
  };

  const isFiltersApplied = useMemo(() => !!appliedFilters.length, [appliedFilters]);

  const { isLoading, messages, clusterRespondents } = useFilterResonanceMessages({
    appliedFilters,
    size,
    sort,
    search,
    projectId,
  });

  useEffect(() => {
    if (isFiltersApplied) {
      setSort(COMMON_LINK_SORT);
    } else {
      setSort(COMMON_MESSAGE_SORT);
    }
  }, [isFiltersApplied]);

  return (
    <div className={scss.tableWrapper}>
      <TopMessagesTableFilters
        onSizeChange={setSize}
        onSortChange={handleChangeSort}
        size={size}
        sort={sort}
        search={search}
        onSearch={setSearch}
        isFiltersApplied={isFiltersApplied}
        clusterRespondents={clusterRespondents}
      />

      <MessagesList
        isLoading={isLoading}
        content={messages}
        searchStr={search}
        selectedMessage={selectedMessage}
        onMessageSelect={onMessageSelect}
      />
    </div>
  );
}

export default TopMessagesTable;

export const COMMON_MESSAGE_SORT = {
  sort: RESONANCE_SORT.TOTAL_MESSAGE,
  direction: SORT_ORDER.DESC,
  getSortValue: (message) => safeSum(message.accurateR1Total, message.accurateR2Total),
};

const COMMON_LINK_SORT = {
  sort: RESONANCE_SORT.TOTAL,
  direction: SORT_ORDER.DESC,
  getSortValue: (message) => message.filteredAccurateTotal,
};
